import { getOrganizationInfo } from '@/api/httpList'
import http from '@/api/http.js' //ajax请求
export const actions = {
  //获取机构信息
  setMechOranization(context, playload) {
    const searchObj = {}
    searchObj.organizationId = playload.id
    if (playload.status) {
      searchObj.status = playload.status
    }
    getOrganizationInfo(searchObj).then(res => {
      context.commit("setMechOranization", res.data);
      if (playload.callback) playload.callback()
    })
  },
  // 地区数据
  getRegion({ state }) {
    if(state.regionsArr&&state.regionsArr.length){
      return state.regionsArr;
    }
    return http({
      url: "/json/region.json",
      type: "GET",
      forced: true,
      data: {},
    }).then((region) => {
      state.regionsArr = region;
      return state.regionsArr
    });
  },
}
